/* MD Masala theme by Zoon Network · zoon.network */
(function () {
  'use strict';
  if (window.MDHelp) return;
  var norm = function (t) {
    return String(t || '').toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '').replace(/[^\p{L}\p{M}\p{N}₹]+/gu, ' ').trim();
  };
  var design = !!(window.Shopify && window.Shopify.designMode);
  var device = function () { var w = window.innerWidth; return w >= 1024 ? 'c' : w >= 600 ? 't' : 'p'; };
  var SHOWS = { all: 'ctp', ct: 'ct', c: 'c', t: 't', tp: 'tp', p: 'p' };
  function offHere(el) {
    if (design) return false;
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
      var v = n.getAttribute('data-show');
      if (v && SHOWS[v] && SHOWS[v].indexOf(device()) < 0) return true;
    }
    return false;
  }

  function faq(root) {
    if (root.mdh) return root.mdh;
    var input = root.querySelector('[data-mdh-filter]');
    var clear = root.querySelector('[data-mdh-clear]');
    var count = root.querySelector('[data-mdh-count]');
    var none = root.querySelector('[data-mdh-none]');
    var chips = root.querySelector('.mdh-faq__chips');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-mdh-group]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-mdh-item]'));
    items.forEach(function (it) { it._t = norm(it.textContent); });
    groups.forEach(function (g) {
      var side = g.querySelector('.mdh-faq__side');
      g._t = side ? norm(side.textContent) : '';
    });

    function run() {
      var q = input ? norm(input.value) : '';
      var words = q ? q.split(' ') : [];
      var shown = 0;
      groups.forEach(function (g) {
        var groupHit = words.length && words.every(function (w) { return g._t.indexOf(w) > -1; });
        var any = 0;
        g.querySelectorAll('[data-mdh-item]').forEach(function (it) {
          var hit = !words.length || groupHit || words.every(function (w) { return it._t.indexOf(w) > -1; });
          it.hidden = !hit;
          if (hit && !offHere(it)) any++;
        });
        g.hidden = !any && !!words.length;
        shown += any;
      });
      if (clear) clear.hidden = !(input && input.value);
      if (chips) chips.hidden = !!words.length;
      if (none) none.hidden = !(words.length && !shown);
      if (count) {
        count.textContent = words.length && shown
          ? (shown === 1 ? count.dataset.one : String(count.dataset.many || '').replace('[n]', shown))
          : '';
      }
    }

    if (input) {
      input.addEventListener('input', run);
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { input.value = ''; run(); } });
      if (clear) clear.addEventListener('click', function () { input.value = ''; run(); input.focus(); });
      if (input.value) run();
    }

    var api = {
      run: run,
      openHash: function () {
        var id = decodeURIComponent((location.hash || '').slice(1));
        if (!id) return;
        var el = document.getElementById(id);
        if (el && el.tagName === 'DETAILS' && root.contains(el)) {
          el.open = true;
          el.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
      },
      select: function (el) {
        if (el === none) { none.hidden = false; return; }
        if (el.closest('.mdh-faq__chips')) {
          var tag = el.getAttribute('data-shopify-editor-block');
          var g = tag && groups.filter(function (x) { return x.getAttribute('data-shopify-editor-block') === tag; })[0];
          if (g) el = g;
        }
        if (el.matches && el.matches('[data-mdh-item]')) {
          if (el.hidden && input) { input.value = ''; run(); }
          el._was = el.open;
          el.open = true;
        }
        if (el.scrollIntoView) el.scrollIntoView({ block: 'center', behavior: 'smooth' });
      },
      deselect: function (el) {
        if (el === none) { run(); return; }
        if (el.matches && el.matches('[data-mdh-item]') && el._was === false) el.open = false;
      }
    };
    root.mdh = api;
    api.openHash();
    return api;
  }

  function boot(scope) {
    scope.querySelectorAll('[data-mdh-faq]').forEach(faq);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);

  window.addEventListener('hashchange', function () {
    document.querySelectorAll('[data-mdh-faq]').forEach(function (r) { if (r.mdh) r.mdh.openHash(); });
  });

  if (design) {
    document.addEventListener('shopify:section:load', function (e) {
      try { boot(e.target); } catch (err) { console.error('help section set-up after an edit', err); }
    });
    var onBlock = function (kind) {
      return function (e) {
        var el = e.target;
        var root = el && el.closest && el.closest('[data-mdh-faq]');
        if (!root) return;
        var api = faq(root);
        api[kind](el);
      };
    };
    document.addEventListener('shopify:block:select', onBlock('select'));
    document.addEventListener('shopify:block:deselect', onBlock('deselect'));
  }
  window.MDHelp = { boot: boot };
})();
